import React from "react";


function Contact() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/bg.jpg)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
       
        <div className="row">
            <div className="col-md-5" style={{background:'#ffffffff',padding:'50px'}}>
               <div className="row" style={{borderBottom:'0px solid orange',paddingBottom:'15px',paddingTop:'15px'}}>
                    <h3 className="cheading" >Address</h3>
                    {/* first */}
                    <div class="row" style={{borderBottom:'1px solid orange',paddingBottom:'15px',marginBottom:'15px',width:'100%'}}>
                        <div className="col-md-1 middle">
                          <i class="fa fa-map-marker contacticons" aria-hidden="true"></i>
                        </div>
                        <div className="col-md-10 middle">
                            <p className="addr">പരമ ഭട്ടാരക ശ്രീ ചട്ടമ്പി സ്വാമി സ്മാരക അഭേദശ്രമം മഹാമന്ത്രാലയം<br />
									സ്വാമി അഭേദാനന്ദ റോഡ്, ഫോർട്ട്, <br />
									തിരുവനന്തപുരം - 23</p>                                               
                        </div>
                    </div>
                    <div class="row" style={{borderBottom:'1px solid orange',paddingBottom:'15px',marginBottom:'15px',width:'100%'}}>
                        <div className="col-md-1 middle">
                          <i class="fa fa-phone-square contacticons" aria-hidden="true"></i>
                        </div>
                        <div className="col-md-10 middle">
                            <p className="addr">0471 - 2450519, 91 701211938</p>                                               
                        </div>
                    </div>
                    {/* <div class="row" style={{borderBottom:'1px solid orange',paddingBottom:'15px',marginBottom:'15px',width:'100%'}}>
                        <div className="col-md-1 middle">
                          <i class="fa fa-envelope contacticons" aria-hidden="true"></i>
                        </div>
                        <div className="col-md-10 middle">
                            <p className="addr">mathilakamofficespst@gmail.com <br />
                              catoeospst@gmail.com
                            </p>                                               
                        </div>
                    </div> */}
                    
                </div>
           </div> 
           <div className="col-md-7" style={{backgroundSize:'cover',backgroundPosition:'center'}}>
             <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7892.327727009769!2d76.94678!3d8.483443!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05bba0b4f2b02f%3A0x11e669b38682002b!2sAbhedasramam!5e0!3m2!1sen!2sus!4v1760781850917!5m2!1sen!2sus"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>


           </div>           
        </div>
        
        
      </div>
    </div>
  );
}

export default Contact;